import React from "react";

const InternetStatus = () => {
  const [isOnline, setIsOnline] = React.useState(true);
  const [isSlow, setIsSlow] = React.useState(false);

  React.useEffect(() => {
    function updateState() {
      setIsOnline(navigator.onLine);
    }

    updateState();
    window.addEventListener("online", updateState);
    window.addEventListener("offline", updateState);

    return () => {
      window.removeEventListener("online", updateState);
      window.removeEventListener("offline", updateState);
    };
  }, []);

  React.useEffect(() => {
    const checkSpeed = async () => {
      if (!navigator.onLine) {
        setIsSlow(false);
        return;
      }

      const start = Date.now();
      const url =
        "https://prod.saraemart.com/Images/Sellers/SellerProfile/329f4e370c4e4570ab4205a6319f889e.png";

      try {
        const response = await fetch(url, { cache: "no-cache" });
        const blob = await response.blob();
        const end = Date.now();

        const duration = (end - start) / 1000;
        const size = blob.size * 8;
        const speed = size / duration / 1_000_000;

        setIsSlow(speed < 3);
      } catch {
        setIsSlow(true);
      }
    };

    checkSpeed();
   
    const interval = setInterval(checkSpeed, 10000);

    return () => clearInterval(interval);
  }, []);

  const getColor = () => {
    if (!isOnline) return "#FF0000"; // offline
    if (isSlow) return "#e6a800"; // slow 
    return "#34C759"; // online with 3 Mbps+ speed
  };

  return (
    <span className="font-10 m-l-5">
      <span
        style={{
          display: "inline-block",
          width: "0.95rem",
          height: "0.95rem",
          borderRadius: "50%",
          background: `${getColor()}`,
        }}
      ></span>
    </span>
  );
};

export default InternetStatus;
